//@flow
import React, {useState, useEffect, useMemo} from "react";
import {Popover, Row, Col, Collapse, Spin} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";

import placeholder from "../../../public/images/person-placeholder.jpg";
import {MarkerContainer, MarkerIcon, BulletText, CourierImg, InfoLink} from "./markerStyles";
import {MarkerPropType} from "./markerPropTypes";
import config from "../../../_core/config";
import {courierTypes, courierStatuses, deliveryStatuses} from "../../../constants/constants";
import {formatPhoneNumber, isConstantExist, getConstant} from "../../../utils/helpers";
import {useStore} from "../../../hooks/useStore";
import moment from "moment";
import {useFetch} from "../../../hooks/useFetch";
import {CourierContent} from "./Popover/CourierContent";

export const CourierMarker = ({
    lat,
    lng,
    icon,
    color,
    allOrdersOfDelivery,
    courierStatus,
    delivery,
    courier,
    zIndex,
    company,
    fromStore,
    regionGroupData,
    courierShift
}: MarkerPropType) => {
    const stores = useStore();
    const history = useHistory();
    const {t} = useTranslation(["courierTypes", "courierStatuses", "deliveryStatuses"]);
    const [subCompanies, setSubCompanies] = useState([]);
    const [regionGroups, setRegionGroups] = useState([]);

    useEffect(() => {
        const subCompanies = [];
        fromStore?.forEach(store =>
            courier?.dedicatedSubCompanies?.forEach(
                dedicatedId => store._id === dedicatedId && subCompanies.push(store.name)
            )
        );
        setSubCompanies(subCompanies);
    }, [courier]);

    useEffect(() => {
        const regionGroups = [];
        regionGroupData.forEach(store =>
            courier?.regionGroups?.forEach(
                regionGroup => store._id === regionGroup._id && regionGroups.push(store.name)
            )
        );
        setRegionGroups(regionGroups);
    }, [regionGroupData]);
    return (
        <MarkerContainer
            lat={lat}
            lng={lng}
            color={color}
            zIndex={zIndex}
            data-testid="map_courierMarker"
        >
            <Popover
                content={
                    <CourierContent courier={courier} courierStatus={courierStatus} delivery={delivery} />
                }
                trigger="click"
            >
                <MarkerIcon icon={icon} color={color} />
            </Popover>
        </MarkerContainer>
    );
};
